import { ObjectUtil } from './object-util';
import { CryptoJsUtil } from './crypto-js-util';
import { environment } from '../../../environments/environment';
import { DefaultFilterConstant } from '../common/models/default-filter-constant.model';
import { EnumConfigModel } from '../common/models/enum-config.model';
import { ProductUtils } from './product-mode.model';
import { Role } from '../../auth_modules/models/role.model';
import { UserTypeEnum } from '../enums/user-type.enum';

export interface BankBranchDto {
  branchCode: string;
  branchName: string;
}

export class LocalStorageUtil {
  /**
   * @description
   * Get an instance of LocalStorage.
   */
  public static getStorage(): LocalStorage {
    return ObjectUtil.isEmpty(localStorage.getItem(environment.appConfigName))
      ? new LocalStorage()
      : JSON.parse(
          CryptoJsUtil.decrypt(localStorage.getItem(environment.appConfigName)),
        );
  }

  /**
   * @param data A local storage instance to save.
   *
   * @description
   * Make sure you use LocalStorageUtil.getStorage() method before
   * to get instance of LocalStorage. Edit the instance and use
   * LocalStorageUtil.setStorage() to set in the browser's localStorage.
   */
  public static setStorage(data: LocalStorage): void {
    localStorage.setItem(
      environment.appConfigName,
      CryptoJsUtil.encrypt(JSON.stringify(data)),
    );
  }

  /**
   * @description
   * Passes empty JSON to clear the storage.
   */
  public static clearStorage(): void {
    LocalStorageUtil.setStorage(new LocalStorage());
  }
}

export class LocalStorage {
  at: string | any;
  rt: string | any;
  ty: string | any;
  et: string | any;
  username: string | any;
  loggedInUserRole: Role = new Role();
  userId: string | any;
  userFullName: string | any;
  userType?: UserTypeEnum;
  roles: any[] = Array<any>();
  enumConfigModel: EnumConfigModel = new EnumConfigModel();
  defaultFilterConstant: DefaultFilterConstant = new DefaultFilterConstant();
  loggedInUserBranch: Array<any> = new Array<any>();
  isDefaultPassword: boolean | any;
  productUtil: ProductUtils = new ProductUtils();
  roleType: string | any;
  bankId: number | any;
  bankBranchList: Array<BankBranchDto> = new Array<BankBranchDto>();
  bankSwiftCode: string | any;
  isOnboardingCompleted: boolean = false;
  needsPasswordChange: boolean = false;
}
